module.exports = __webpack_public_path__ + "img/bevfam_reward_btn.7c8885a6.png";